import React from 'react'
import { Outlet } from 'react-router-dom'
import Nav from './Nav'

const Layout = () => {
  return (
    <>
      <Nav />
      <div className="h-full p-4">
        <Outlet />
      </div>
    </>
  )
}

export default Layout
